/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import React, {Component, useState} from 'react';
import "../../CSS/DataModal.css";
import FullLoader from "../Loader/FullLoader";
import CommonModal from "../CommonModal/CommonModal";
import DatePicker from "react-datepicker";
import moment from "moment/moment";
import {notificationTime} from "../../componentObjects";

const initAlert = {
    alertTypeId: -1,
    startDate: null,
    endDate: null,
    message: ""
}
function CreateAlertModal(props) {
    const { show, onClick, onYes, alertTypes, assetId } = props;
    const [loading, setLoading] = useState(false);
    const [newAlert, setNewAlert] = useState(initAlert);
    
    const [selectedAlertType, setSelectedAlertType] = useState(-1);
    const [selectedStartDate, setSelectedStartDate] = useState(null);
    const [selectedStartDateStr, setSelectedStartDateStr] = useState("");
    const [selectedEndDate, setSelectedEndDate] = useState(null);
    const [selectedEndDateStr, setSelectedEndDateStr] = useState("");
    const [message, setMessage] = useState("");

    const onCancel = () => {
        setLoading(false);
        setNewAlert(initAlert);
        
        setSelectedAlertType(null);
        setSelectedStartDate(null);
        setSelectedEndDate(null);
        setMessage("");
        
        onClick();
    }
    
    const onContinue = () => {
        const selectedAlertTypeId = (selectedAlertType !== -1 && selectedAlertType !== null)
            ? selectedAlertType
            : (alertTypes?.[0]?.alertTypeId ?? -1);

        if (selectedAlertTypeId === -1) return;

        setSelectedAlertType(selectedAlertTypeId);
        let addAlert = {
            alertTypeId: selectedAlertTypeId.toString(),
            startTime: selectedStartDateStr,
            endTime: selectedEndDateStr,
            message: message,
            comment: "Created on " + moment().format(),
            sourceId: assetId
        }
        onYes(addAlert);
        onCancel(); // reset modal
    }
    
    const onChangeAlertType = (e) => {
        newAlert.alertTypeId = e.target.value;
        setNewAlert(newAlert);
        setSelectedAlertType(e.target.value);
    }

    const onChangeDate = (e, isStart) => {
        if(!e) return ;
        let editAlert = newAlert;
        let date = moment(e).toDate();
        let dateStr = moment(e).format();
        
        if (isStart) {
            editAlert.startDate = dateStr;
            setSelectedStartDate(date);
            setSelectedStartDateStr(dateStr);
        }
        else {
            editAlert.endDate = dateStr;
            setSelectedEndDate(date);
            setSelectedEndDateStr(dateStr);
        }
        setNewAlert(editAlert);
    }
    
    const onChangeMessage = (e) => {
        newAlert.message = e.target.value;
        setNewAlert(newAlert);
        setMessage(e.target.value);
    }
    
    let modalContent = <div className={"text-left"}>
        <br/>
        <div>
            <label htmlFor="description">Alert Type</label>
            <select className="form-control" value={selectedAlertType} onChange={onChangeAlertType}>
                {alertTypes.map((type, index) =>
                    <option key={`${index}-${type.alertTypeId}`} id={`${index}-${type.alertTypeId}`} value={type.alertTypeId}>{type.name}</option>
                )}
            </select>
        </div>
        <div>
            <label htmlFor="description">Start Time</label>
            <DatePicker
                customInput={<input className="form-control" />}
                id="muteDate"
                name="muteDate"
                selected={selectedStartDate}
                onChange={date => onChangeDate(date, true)}
                dateFormat="MM/dd/yyyy hh:mm:ss aa"
                timeIntervals={15}
                showTimeSelect
                showMonthYearDropdown
                popperPlacement="top-end"
                popperProps={{
                    positionFixed: true
                }}
            />
        </div>
        <div>
            <label htmlFor="description">End Time</label>
            <DatePicker
                customInput={<input className="form-control " />}
                id="endDate"
                name="endDate"
                selected={selectedEndDate}
                onChange={date => onChangeDate(date, false)}
                dateFormat="MM/dd/yyyy hh:mm:ss aa"
                timeIntervals={15}
                showTimeSelect
                showMonthYearDropdown
                popperPlacement="top-end"
                popperProps={{
                    positionFixed: true
                }}
            />
        </div>
        <div>
            <label htmlFor="description">Message</label>
            <input
                type="text"
                className="form-control"
                id="message"
                value={message}
                onChange={onChangeMessage}
            />
        </div>
        <br/>
    </div>;

    if (show) {
        return (
            <div>
                <CommonModal show={show} onYes={onContinue} onClick={onCancel} content={modalContent} title={'Create Alert'} />
            </div>
        )
    }
    else {
        return null;
    }
}

export default CreateAlertModal;